"use client"

import ClientOnly from "library/ClientOnly"
import { css, fresponsive, styled } from "library/styled"
import { useMedia } from "library/useMedia"
import { useResponsivePixels } from "library/viewportUtils"
import ReactPlayer from "react-player"
import type { SourceProps } from "react-player/base"

export function YoutubeEmbed({
	className,
	video,
}: {
	className?: string
	video: { url?: string | string[] | SourceProps[] | MediaStream }
}) {
	if (!video.url) return null
	const width = useResponsivePixels(useMedia(1032, 1032, 944, 327))
	const height = useResponsivePixels(useMedia(580, 580, 531, 184))

	return (
		<ClientOnly>
			<ReactPlayerWrapper>
				<ReactPlayer
					width={width}
					height={height}
					url={video.url}
					className={className}
				/>
			</ReactPlayerWrapper>
		</ClientOnly>
	)
}

const ReactPlayerWrapper = styled("div", {
	...fresponsive(css`
		display: grid;
		width: 100%;
		height: auto;
		border-radius: 16px;
		overflow: clip;
	`),
})
